import { useState, useEffect } from 'react';
import { Container, OptionContainer,  OptionButton } from './styles';

/**
 * Componente para controle responsável pelo modo de operação 
 * @param {boolean} State estado inicial da aplicação
 * @param {Function} onChange muda o estado da aplicação
 * @param {boolean} isNewValue indica se o valor é novo inserido pelo usuário
 * @returns {ReactComponentElement} 
 */
const OperationMode = ({ id, State, onChange, isNewValue }) => {
    // Exemplo de função para ser utilizada onChange
    // const currentState = useRef(false)
    // const onChange = (newState)=>{
    //     currentState.current = newState;
    // }
    const [selectedOption, setSelectedOption] = useState(State);

    const handleOptionClick = (option) => {
        onChange(option);
        setSelectedOption(option);
    };

    useEffect(() => {
        setSelectedOption(State)
    }, [State])
  
    return (
        <Container id={id}>
            <OptionContainer selected={parseInt(selectedOption)? parseInt(selectedOption) : null}>
                <OptionButton
                    disabled={selectedOption === 0}
                    selected={selectedOption === 0}
                    isNewValue={isNewValue}
                    onClick={() => handleOptionClick(0)}>
                    M
                </OptionButton>
                <OptionButton
                    disabled={selectedOption === 1}
                    selected={selectedOption === 1}
                    isNewValue={isNewValue}
                    onClick={() => handleOptionClick(1)}>
                    A
                </OptionButton>
                <OptionButton
                    disabled={selectedOption === 2}
                    selected={selectedOption === 2}
                    isNewValue={isNewValue}
                    onClick={() => handleOptionClick(2)}>
                    S
                </OptionButton>
            </OptionContainer>
        </Container>
    );
};

export default OperationMode;